import React from 'react';

const logoUrl = 'https://qntx2.publit.io/file/GFInternational/GFInter-logo.png';

function Brand({compact = false,light = false,auth = false}) {
  const height = auth ? 68 : compact ? 32 : 40;

  return (
    <div className={`brand ${light ? 'brand-light' : ''}`} style={{minWidth: 0}}>
      <img
        src={logoUrl}
        alt="GFI International"
        style={{
          display: 'block',
          filter: light ? 'brightness(0) invert(1)' : 'none',
          height,
          maxWidth: compact ? 150 : auth ? 300 : 240,
          objectFit: 'contain',
          width: 'auto'
        }}
      />
    </div>
  );
}

export default Brand;